<table class="workflows-table">
    <thead>
        <tr>
            <th class="workflows-step-th">Etape</th>
            <th class="workflows-name-th">Nom</th>
            <th class="workflows-state-th">État</th>
            <th class="workflows-date-th">Date de début</th>
            @if (isDateVisible) {
                <th class="workflows-date-th">Date modification</th>
            }
            <th class="workflows-deadline-th">Echéance</th>
        </tr>
    </thead>
    <tbody>
        @for (workflowStep of workflowStepDefinitions; track workflowStep.id) {
            <tr (contextmenu)="$event.preventDefault(); onContextMenuClick($event, workflowStep, stepSnapshots[workflowStep.id])">
                <td class="workflows-step-td">{{ workflowStep.step }}</td>
                <td class="workflows-name-td">{{ workflowStep.name }}</td>
                <td class="workflows-state-td">
                    <app-workflow-step
                        [currentStateId]="stepSnapshots[workflowStep.id] ? stepSnapshots[workflowStep.id].currentStateId.toString() : 'N/A'"
                        [completed]="stepSnapshots[workflowStep.id] ? stepSnapshots[workflowStep.id].completed : false"
                        [states]="workflowStep.states"
                        [readonly]="readonly"
                        (stateUpdated)="onUpdateFolderWorkflowStepState(workflowStep, $event)"></app-workflow-step>
                </td>
                <td class="workflows-date-td">
                    <span>{{ (stepSnapshots[workflowStep.id] ? stepSnapshots[workflowStep.id].stepStartDate : null) | AvmDate }}</span>
                </td>
                @if (isDateVisible) {
                    <td class="workflows-date-td">
                        <span>{{ (stepSnapshots[workflowStep.id] ? stepSnapshots[workflowStep.id].currentStateDate : null) | AvmDate }}</span>
                    </td>
                }
                <td class="workflows-deadline-td">
                    @if (workflowStepDeadlineStatus[workflowStep.id]) {
                        <div class="deadline-container">
                            @if (workflowStepDeadlineStatus[workflowStep.id].status !== DeadlineStates.Undefined) {
                                <fa-icon
                                    [icon]="deadlineStatusIcon"
                                    class="deadlineStatusIcon"
                                    [class]="workflowStepDeadlineStatus[workflowStep.id].status"
                                    [matTooltip]="workflowStepDeadlineStatus[workflowStep.id].statusLabel"
                                    matTooltipPosition="below"></fa-icon>
                            }
                        </div>
                    }
                </td>
            </tr>
        }
    </tbody>
    <ngx-spinner name="workflow-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
</table>
<!-- Menu contextuel pour pouvoir marquer comme lu/non lu et ajouter l'emetteur aux contacts -->
<app-workflow-context-menu
    [ngStyle]="getContextMenuStyle()"
    [contextMenuItems]="contextMenuItems"
    (onContextMenuItemClick)="onContextMenuItemClick($event)"></app-workflow-context-menu>
